<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroWhyUs" />
    <Section :content="peaceOfMind" />
    <Section :content="speedToRecovery" />
    <Section :content="transparency" />
    <Section :content="expertAdvice" />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
import CallToActionAconexRegister from '../components/call-to-action-aconex-register.vue';
export default {
  name: 'Recovery',
  components: {
    MainNavBar,
    Hero,
    Section,
    CallToAction,
    GmxFooter,
    CallToActionAconexRegister
  },
  data() {
    return { 
      heroWhyUs: { 
        eyebrowIcon: '',
        eyebrowTitle: '',
        eyebrowSubtitle: '',
        header: 'Why Us',
        subheader: 'Our experts will help you navigate the complexities of the recovery process and provide you with real-time visibility and access to the progress of your recovery journey. Our streamlined process accelerates recovery timelines by partnering with qualified contractors, architects, and expeditors for speedy recovery.',
        html: '',
        img: 'placeholder.png',
        videoId: '',
        buttons: [
          { label: 'Peace of Mind', path: '', id: 'peace-of-mind' },
          { label: 'Recovery Speed', path: '', id: 'speed-to-recovery' },
          { label: 'Transparency', path: '', id: 'transparency' },
          { label: 'Expert Advice', path: '', id: 'expert-advice' },
        ]
      },
      peaceOfMind: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Peace of Mind',
        paragraphs: [
          'Recovering from the loss of your home is both emotionally and physically exhausting. At Graphmetrix, we prioritize your well-being by taking the burden of day-to-day management and oversight off your shoulders. Our experienced team handles every detail, ensuring you can focus on healing and spending time with your family while we manage the recovery process on your behalf.',
        ],
        html: '',
        id: 'peace-of-mind',
        image: 'placeholder.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      speedToRecovery: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Speed to Recovery',
        paragraphs: [
          'We understand the urgency of rebuilding and restoring your life. Our streamlined process accelerates recovery timelines by partnering with qualified contractors, architects, and expeditors. With continual oversight, we address challenges proactively, ensuring your project progresses smoothly and efficiently. Our goal is to bring closure to this chapter as quickly as possible without compromising quality.',
        ],
        html: '',
        id: 'speed-to-recovery',
        image: 'placeholder.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      transparency: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Transparency',
        paragraphs: [
          'Trust is built on transparency, and we believe you should always have access to the progress of your recovery journey. Through our cutting-edge Graphmetrix Trinpod platform, you\'ll have real-time visibility into every stage of the process. From project milestones to pending decisions, you\'ll have the information you need at your fingertips to stay informed and confident in the progress.',
        ],
        html: '',
        id: 'transparency',
        image: 'placeholder.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      expertAdvice: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Expert Advice',
        paragraphs: [
          'Navigating the complexities of the recovery process can be overwhelming, especially when it comes to making critical decisions. Our team of experts is here to guide you every step of the way, offering clear, actionable advice tailored to your unique circumstances. From design choices to budget considerations, you\'ll have a trusted advisor to help you make informed decisions with confidence.',
        ],
        html: '',
        id: 'expert-advice',
        image: 'placeholder.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
    }
  }
};
</script>
